export default {
    complete: () => {
        import( /* webpackChunkName: "plugins/am2-Slider" */ "../../plugins/am2-Slider").then(() => {
            const { Slider } = am2; 
            Slider.init(document.querySelectorAll('[data-plugin-slider]'));
        });
    },
    extends: ['page']
};

// export default {
// 	complete: () => {
// 		import( /* webpackChunkName: "plugins/am2-Slider" */ "./../../plugins/am2-Slider").then(() => {
// 			const { Slider } = am2;
// 			Slider.init(document.querySelectorAll('[data-plugin-slider]'));
// 		});
// 	},
// };